import React from 'react';
import { useTheme } from '@/hooks/useTheme';

export function BrandLogo({ className = "size-6" }: { className?: string }) {
  const { theme } = useTheme();

  // Dim or dark mode -> white logo on dark background (JPG)
  // Light mode -> custom dark logo (PNG)
  const logoSrc = (theme === 'light')
    ? '/logo-light.png'
    : '/logo-dark.jpg';

  return (
    <img 
      src={logoSrc} 
      alt="Twittstr" 
      className={`${className} object-contain rounded-lg`}
    />
  );
}
export default BrandLogo;